/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Specifies the desired decommissioning method of the device.
 */
export enum DeviceDecommissionTargetType {
  DeviceDecommissionTargetTypeUnenroll = 'Unenroll',
  DeviceDecommissionTargetTypeFactoryReset = 'FactoryReset',
}
